import SimpleBar from "simplebar";
import "simplebar/dist/simplebar.css";

window.addEventListener("DOMContentLoaded", event => {
    for (let scrollable of [
        ...document.querySelectorAll(".scrollable-section-container")
    ]) {
        const isDesktop = scrollable.classList.contains(
            "scrollable-section-container--desktop"
        );
        new SimpleBar(scrollable, {
            autoHide: false,
            scrollbarMaxSize: 500,
            forceVisible: true,
            ...(isDesktop && {
                classNames: {
                    contentWrapper: "dragscroll"
                }
            })
        });
    }
    window.dragscrollReset();
});
